var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextboxSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 15.5832V2.83317C1.4165 2.44359 1.55522 2.11008 1.83265 1.83265C2.11008 1.55522 2.44359 1.4165 2.83317 1.4165H14.1665C14.5561 1.4165 14.8896 1.55522 15.167 1.83265C15.4445 2.11008 15.5832 2.44359 15.5832 2.83317V11.3332C15.5832 11.7228 15.4445 12.0563 15.167 12.3337C14.8896 12.6111 14.5561 12.7498 14.1665 12.7498H4.24984L1.4165 15.5832ZM3.64775 11.3332H14.1665V2.83317H2.83317V12.13L3.64775 11.3332Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6H8.5H12M5 9H12",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextboxSelected);
export default __webpack_public_path__ + "static/media/textbox-selected.7663de7f5a61aa038616a8c15a1784b0.svg";
export { ForwardRef as ReactComponent };